import { Component, Host, h, Listen, Element, Prop, Watch } from '@stencil/core';

export interface AhaTabs extends HTMLAhaTabsElement {}

@Component({
  tag: 'aha-tabs',
  styleUrl: 'aha-tabs.css',
  shadow: true,
})
export class AhaTabs {
  @Element() host!: HTMLAhaTabsElement;

  @Prop({ mutable: true }) selectedTabIndex: number = -1;

  @Listen('tabChosenAtIndex')
  handleTabChosen(event: CustomEvent<number>) {
    this.selectedTabIndex = event.detail;
  }

  @Watch('selectedTabIndex')
  selectedTabIndexChanged() {
    this.tabList?.selectTabAtIndex(this.selectedTabIndex);
    if (this.tabPanels) this.tabPanels.visibleIndex = this.selectedTabIndex;
  }

  private get tabList() {
    return this.host.querySelector('aha-tab-list');
  }

  private get tabPanels() {
    return this.host.querySelector('aha-tab-panels');
  }

  componentWillLoad() {
    requestAnimationFrame(() => {
      let selectedTabIndex = 0;
      const tabList = this.host.querySelector('aha-tab-list');

      // Select the first selected tab, if one exists
      if (tabList?.shadowRoot) {
        const tabs = Array.from(tabList.shadowRoot.querySelectorAll('aha-tab'));
        selectedTabIndex = Math.max(
          0,
          tabs.findIndex(tab => tab.selected),
        );
      }

      this.selectedTabIndex = selectedTabIndex;
    });
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
